import React, { useState } from 'react';
import Nav           from '../components/Nav';
import Sidebar       from '../components/Sidebar';
import Chat          from '../components/Chat';
import Atendentes    from './Atendentes';
import Relatorios    from './Relatorios';
import ConfigIA      from './ConfigIA';
import Conexoes      from './Conexoes';
import CRM           from './CRM';
import Configuracoes from './Configuracoes';
import { useAuth } from '../contexts/AuthContext';

export default function App() {
  const { usuario }   = useAuth();
  const [view, setView]       = useState('chat');
  const [selConv, setSelConv] = useState(null);

  const isAdmin      = usuario?.perfil === 'admin';
  const isSuperAdmin = ['admin','supervisor'].includes(usuario?.perfil);

  function handleResolvida(id) {
    if (selConv?.id === id) setSelConv(null);
  }

  return (
    <div style={styles.root}>
      <Nav view={view} setView={setView} />

      {view === 'chat' && (
        <>
          <Sidebar selConvId={selConv?.id} onSelect={setSelConv} />
          <Chat conv={selConv} onResolvida={handleResolvida} />
        </>
      )}

      {view === 'relatorios'    && isSuperAdmin && <Relatorios />}
      {view === 'atendentes'    && isAdmin      && <Atendentes />}
      {view === 'config-ia'     && isAdmin      && <ConfigIA />}
      {view === 'conexoes'      && isAdmin      && <Conexoes />}
      {view === 'crm'           && isSuperAdmin && <CRM />}
      {view === 'configuracoes' &&                 <Configuracoes />}
    </div>
  );
}

const styles = {
  root: {
    display: 'flex',
    height: '100vh',
    overflow: 'hidden',
    background: 'var(--bg-app)',
  },
};